import { environment } from '../../../environments/environment';

export class ProductMappingControl {

  constructor() {  }
  /**
   * @method getApiEndpoint returns the end point to call the product configurations
   */
  public get getApiEndpoint(): string {
    return environment.ProductCatalog.apis.productConfiguration;
  }

  /**
  * @method getApiRequest returns the api request
  * @arg products should contains the product informaion
  * @arg capability should contains selected capability
  * @returns apiRequest should contains the processed product information
  **/
  public getApiRequest(products: any, capability: string): object[] {
    const apiRequest = [];
    const product = {};
    product['productName'] = products.value.productCode;
    product['svppProductName'] = products.value.productDescription;
    product['productCode'] = 'PROD_' + products.value.productCode.toUpperCase();
    product['zuoraName'] = products.value.productCode[0].toUpperCase() + products.value.productCode.slice(1);
    product['capabilities'] = capability;
    apiRequest.push(product);
    return apiRequest;
  }

  /**
  * @method getApitype returns api type
  * @returns objectapproveAsi
  **/
  public get getApiType(): object {
    return { type: 'productConfig' };
  }

  /**
  * @method getCapabilityApiType returns capability api type
  * @returns objectapproveAsi
  **/
 public getCapabilityApiType(generation: string): object {
  return { type: 'getCapability', params: { generation: generation } };
}
  /**
   * @method getCapabilityApiEndpoint returns the end point to call the asi capabilities
   */
  public get getCapabilityApiEndpoint(): string {
    return environment.ProductCatalog.apis.asiCapabilities;
  }
}
